import TotalProductsV2Provider from './hooks/useTotalProductsV2';

import { TotalProductsV2Props } from './@types/TotalProductsV2Props';
import Content from './handles/Content';

const TotalProductsV2 = (props: TotalProductsV2Props) => (
	<TotalProductsV2Provider {...props}>
		<Content />
	</TotalProductsV2Provider>
);

export default TotalProductsV2;
